import React from 'react'
import InputField from 'components/molecules/input-field'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import { Button } from 'reactstrap'

const propTypes = {
  title            : PropTypes.string,
  name             : PropTypes.string,
  messages         : PropTypes.obj,
  handleSubmitNote : PropTypes.func
}

/**
 * @param {string} name - name of the input type
 * @param {Function} handleSubmitNote - this function will handle formik data to be processed
 */
const CustomerRefundNoteForm = ({ name, handleSubmitNote }) => (
  <>
    <Formik
      enableReinitialize={ false }
      initialValues={{
        [ name ]: ''
      }}
      onSubmit={ handleSubmitNote }
    >
      {
        (formik) => (
          <Form>
            <InputField
              name={ name }
              type='textarea'
              validate={ (value) => { if (value === '') return 'Required' } }
            />
            <Button
              className='float-right'
              color='primary'
              type='submit'
              disabled={ formik.isSubmitting }
            >
                Add new note
            </Button>
          </Form>
        )
      }
    </Formik>
  </>
)

CustomerRefundNoteForm.propTypes = propTypes

export default CustomerRefundNoteForm
